export default __webpack_public_path__ + "static/media/APN-news-Sanathan.2d0ee10a.png";